'use client';

import { useTranslations } from 'next-intl';

// Business Google review link (overridable via env without a code change).
const REVIEW_URL =
  process.env.NEXT_PUBLIC_GOOGLE_REVIEW_URL || 'https://g.page/r/CeDUmNoUHst7EAE/review';

/** Official multi-colour Google "G". */
function GoogleG({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" />
      <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" />
      <path fill="#FBBC05" d="M11.69 28.18c-.44-1.32-.69-2.73-.69-4.18s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24s.85 6.91 2.34 9.88l7.35-5.7z" />
      <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z" />
    </svg>
  );
}

export function GoogleReviewCard() {
  const t = useTranslations('public');

  return (
    <div className="pub-card" style={{ padding: '16px', borderColor: 'rgba(34,197,94,0.2)' }}>
      <div className="flex items-start gap-3">
        {/* Google logo */}
        <div
          className="flex items-center justify-center flex-shrink-0"
          style={{
            width: 44,
            height: 44,
            borderRadius: 12,
            background: '#fff',
            border: '1px solid var(--pub-border)',
          }}
        >
          <GoogleG size={24} />
        </div>

        <div className="flex-1 min-w-0">
          {/* Stars */}
          <div aria-hidden="true" style={{ color: '#f5b400', fontSize: 14, letterSpacing: 2, lineHeight: 1 }}>
            ★★★★★
          </div>

          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--pub-text-primary)', marginTop: 6 }}>
            {t('googleReview.title')}
          </div>
          <p style={{ fontSize: 12.5, color: 'var(--pub-text-secondary)', marginTop: 4, lineHeight: 1.5 }}>
            {t('googleReview.body')}
          </p>

          <a
            href={REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2"
            style={{
              marginTop: 12,
              width: '100%',
              padding: '11px 16px',
              borderRadius: 12,
              background: 'var(--pub-green)',
              color: '#fff',
              fontSize: 14,
              fontWeight: 600,
              fontFamily: 'var(--font-pub-display)',
              textDecoration: 'none',
            }}
          >
            <span
              className="flex items-center justify-center"
              style={{ width: 18, height: 18, borderRadius: 4, background: '#fff', flexShrink: 0 }}
            >
              <GoogleG size={12} />
            </span>
            {t('googleReview.button')}
          </a>

          <div style={{ fontSize: 11, color: 'var(--pub-text-muted)', marginTop: 6, textAlign: 'center' }}>
            {t('googleReview.subtext')}
          </div>
        </div>
      </div>
    </div>
  );
}
